// extracted by mini-css-extract-plugin
module.exports = {"content":"Recruitment_content__2TCsE","footer":"Recruitment_footer__2QqRB","label":"Recruitment_label__Ye31b"};